module.exports = __webpack_public_path__ + "03e7c2e2e16d131a.svg";